import React from 'react';
import styled from 'styled-components';

const InfoRaw = ({ className }) => {
  return (
    <div className={className}>
      <h3>Links</h3>
      <About>
        <ul>
          <li>
            <a href="https://confluence.cdk.com/pages/viewpage.action?pageId=224508496">Radial Home on Confluence</a>
          </li>
          <li>
            <a href="https://teams.microsoft.com/l/team/19%3a5OQk8UVKHgg55PY4w0NZBSuTuQzz1J2TurzZvY5ffqE1%40thread.tacv2/conversations?groupId=4fe3bd50-8b75-466f-8cd2-eadac46372ae&tenantId=2916a955-0360-416d-ba9a-1608933b9065">
              Radial Support on Teams
            </a>
          </li>
          <li>
            <a href="https://svc-radial-storybook.ext.nebula.connectcdk.com/?path=/story/general-information-introduction-radial-design-system--page">
              Storybook: cdk-radial
            </a>
          </li>
          <li>
            <a href="https://github.com/cdk-prod/cdk-radial">GitHub: cdk-radial</a>
          </li>
          <li>
            <a href="https://github.com/cdk-prod/radial-park">GitHub: radial-park</a>
          </li>
        </ul>
      </About>
    </div>
  );
};

const About = styled.div``;

const Info = styled(InfoRaw)`
  h3 {
    margin-top: 11px;
  }
  ul {
    margin-top: 12px;
    padding-left: 15px;
  }
  li {
    margin: 0 0 4px 0;
    padding: 0;
    font-size: 0.9em;
    line-height: 1.6;
  }
  a,
  a:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.color.additional.dark.value};
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[400].value};
    padding-bottom: 1px;
  }
  a:hover {
    border-bottom-color: transparent;
    color: ${({ theme }) => theme.color.primary[600].value};
  }
`;

export { Info };
